<!-- <app-header></app-header><br> -->
<div class="wrapper">
  <app-header></app-header>

  <div class="content "><br>
    <div *ngIf="listingData">
      <!-- <div class="col-12 first-container ">
    <div class="listing-image">
      <ng-container *ngIf="Images.length > 0; else noImage">
        <app-image-slide [slides]="Images"></app-image-slide>
      </ng-container>
      <ng-template #noImage>
        <app-image-slide [slides]="['../../assets/images/Images_not_found (1).png']"></app-image-slide>
      </ng-template>
    </div>
    </div> -->
      <div class="container-img">
        <div class="row g-3">
          <div class="col-lg-8">
            <div class="main-image-container position-relative rounded overflow-hidden">
              <img
                [src]="mainImage || '../../assets/images/Images_not_found (1).png'"
                class="img-fluid w-100 h-100 object-fit-cover position-absolute top-0 start-0 z-0"
                alt="Main Image Background" />
              <ng-container [ngSwitch]="viewMode">
                <img *ngSwitchCase="'image'"
                  class="img-fluid w-100 h-100 object-fit-cover position-relative z-1"
                  [src]="mainImage || '../../assets/images/Images_not_found (1).png'"
                  alt="Main Image" />
                <div *ngSwitchCase="'gallery'"
                  class="gallery-view position-relative z-2 d-flex flex-wrap h-40 overflow-auto p-2">
                  <img *ngFor="let img of galleryImages"
                    [src]="img"
                    class="gallery-thumbnail m-1"
                    alt="Gallery Image" (click)="openImageModal(img)" />
                </div>

                <!-- Video View -->
                <div *ngSwitchCase="'video'"
                  class="gallery-view position-relative z-2 d-flex flex-wrap h-40 overflow-auto p-2">
                  <video *ngFor="let video of galleryVideos"
                    [src]="video"
                    muted
                    class="gallery-video m-1"
                    (click)="openVideoModal(video)">
                  </video>
                </div>
              </ng-container>
              <!-- Image Gallery -->
              <div *ngIf="viewMode === 'gallery'"
                class="d-flex flex-wrap h-100 overflow-auto p-2 gallery-view">
                <img *ngFor="let img of galleryImages"
                  [src]="img"
                  class="gallery-thumbnail"
                  (click)="openImageModal(img)"
                  alt="Gallery Image" />
              </div>

              <!-- Video Gallery -->
              <div *ngIf="viewMode === 'video'"
                class="d-flex flex-wrap h-100 overflow-auto p-2 gallery-view">
                <video *ngFor="let video of galleryVideos"
                  [src]="video"
                  muted
                  class="gallery-video"
                  (click)="openVideoModal(video)">
                </video>
              </div>
            </div>

          </div>

          <!-- Right: Thumbnails -->
          <div class="col-lg-4 d-flex flex-column justify-content-between">
            <!-- All Photos -->
            <div class="media-box position-relative mb-3">
              <img
                [src]="galleryImages[1] || '../../assets/images/Images_not_found (1).png'"
                class="img-fluid w-100 h-100 object-fit-cover rounded"
                alt="All Photos" />

              <div class="overlay-text-center text-center"
                (click)="toggleGallery()" style="cursor: pointer;"
                *ngIf="galleryImages.length > 0">
                <div class="d-flex flex-column align-items-center">
                  <i class="fa"
                    [ngClass]="viewMode === 'gallery' ? 'fa-arrow-left' : 'fa-image'"></i>
                  <div style="margin-top: 5px;">
                    {{ viewMode === 'gallery' ? 'Back' : 'All Photos' }}
                  </div>
                </div>
              </div>

            </div>

            <!-- All Videos -->
            <div class="media-box position-relative">

              <ng-container
                *ngIf="galleryVideos.length > 0; else showFallbackImage">
                <div *ngFor="let video of galleryVideos">
                  <video
                    [src]="video"
                    class="img-fluid w-100 h-100 object-fit-cover rounded"
                    controls>
                  </video>
                </div>
              </ng-container>

              <ng-template #showFallbackImage>
                <img
                  src="../../assets/images/not-video.png"
                  class="img-fluid w-100 h-100 object-fit-cover rounded"
                  alt="No video available" />
              </ng-template>

              <div class="overlay-text-center text-center"
                (click)="toggleVideo()" style="cursor: pointer;"
                *ngIf="galleryVideos.length > 0">
                <div class="d-flex flex-column align-items-center">
                  <i
                    class="{{ viewMode === 'video' ? 'fa fa-arrow-left me-2' : 'fa fa-video me-2' }} me-2"></i>
                </div>
                <div style="margin-top: 5px;">
                  {{ viewMode === 'video' ? 'Back' : 'All Videos' }}

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <ng-template #videoModal>
        <div class="modal-backdrop show" style="z-index: 1040;"></div>
        <div class="modal d-block"
          style="background: rgba(0,0,0,0.6); z-index: 1050;"
          (click)="closeVideoModal()">
          <div class="modal-dialog modal-dialog-centered modal-lg"
            (click)="$event.stopPropagation()">
            <div class="modal-content bg-dark position-relative">

              <!-- Close Button -->
              <button type="button"
                (click)="closeVideoModal()"
                style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 1.5rem; color: white; z-index: 999;">
                &times;
              </button>

              <div class="modal-body text-center p-0">
                <video [src]="selectedVideo" class="w-100 rounded" controls
                  autoplay></video>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-container *ngIf="isVideoModalOpen">
        <ng-container *ngTemplateOutlet="videoModal"></ng-container>
      </ng-container>

      <div class="first-container">

        <div class="row g-3">
          <div class="col-lg-8">
            <mat-card class="project-overview " style="text-align: center;">
              <mat-card-title class="project-title mb-3">
                <div>
                  {{ listingData.title | capitalizeFirstLetter}}
                </div>
                <div
                  style="display: flex; justify-content: center; align-items: center; gap: 8px; font-size: 24px; font-weight: bold;">
                  <span style="color: #004aad;">
                    <!-- ₹{{
                    listingData.propertyRentPrice }} -->
                    {{ listingData.propertyRentPrice ? ('₹' + listingData.propertyRentPrice.toLocaleString('en-IN')) : '₹10,000' }}
                    </span>
                  <span style="color: #000; font-weight: 200;">|</span>
                  <span
                    style="color: #000; font-size: 20px; font-weight: 500;">{{
                    listingData.buildupArea }} Sqft</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="project-details">
                  <div class="detail">
                    <i class="fas fa-map-marker-alt" style="color: black;"></i>
                    <strong>{{listingData.area | capitalizeFirstLetter}}
                      {{listingData.cityName}}
                      {{listingData.stateName}}</strong>
                  </div>

                </div>

                <div class="detail1 mt-3">
                  <div class="description">{{listingData.description}}</div>
                </div>
                <hr
                  style="height: 2px; background-color: rgb(224, 224, 224); border: none;">
                <div class="container mt-4">
                  <div class="row " style="text-align: start;">
                    <div class="col-md-4 mb-3">
                      <div class="text-muted"> Property Type</div>
                      <div class="fw-semibold">{{ listingData.type }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Status</div>
                      <div class="fw-semibold">{{
                        listingData.status }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Condition</div>
                      <div class="fw-semibold">{{ listingData.furnishing
                        }}</div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">What do you have?</div>
                      <div class="fw-semibold">{{ listingData.propertyType }}
                      </div>
                    </div>

                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Cover Area</div>
                      <div class="fw-semibold">{{ listingData.coverArea }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Age Of Construction</div>
                      <div class="fw-semibold">{{ listingData.construction }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Parking</div>
                      <div class="fw-semibold">{{
                        listingData.widthOfFacingRoadUnit }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Floor</div>
                      <div class="fw-semibold">{{ listingData.totalFloors }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Water Supply</div>
                      <div class="fw-semibold">{{ listingData.waterSource }}
                      </div>
                    </div>
                    <div class="col-md-4 mb-3">
                      <div class="text-muted">Maintenance Charge</div>
                      <div class="fw-semibold">{{ listingData.maintenanceCharge
                        }}
                      </div>
                    </div>
                  </div>
                </div>

              </mat-card-content>
            </mat-card>

          </div>

          <div class="col-lg-4">

            <div class="contact-card mt-3">
              <h3>Contact owner</h3>
              <div class="name">{{ listingData?.user?.fullName }}</div>
              <div class="phone" *ngIf="listingData?.user?.mobileNumber"><i
                  class="fa fa-phone"></i>
                +91{{listingData?.user?.mobileNumber?.substring(0, 2) + 'XXXXXXXX'
                }}
              </div>
              <button class="connect-btn setbutton"
                (click)="openContactDetailsDialog(listingData)">Connect
                Now</button>
            </div>

            <div class="rounded amenuties mt-3"
              style="background-color: #dee9fb;">
              <div class="row">

                <div *ngIf="hasAmenity('Security')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-lock me-2"></i>
                  <span>Security</span>
                </div>

                <div *ngIf="hasAmenity('Garden')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-leaf me-2"></i>
                  <span>Garden</span>
                </div>

                <div *ngIf="hasAmenity('Gym')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-bolt me-2"></i>
                  <span>Gym</span>
                </div>

                <div *ngIf="hasAmenity('Guest Suite')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-bell me-2"></i>
                  <span>Guest Suite</span>
                </div>

                <div *ngIf="hasAmenity('Banquet Hall')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-glass me-2"></i>
                  <span>Banquet Hall</span>
                </div>

                <div *ngIf="hasAmenity('Meeting Room')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-users me-2"></i>
                  <span>Meeting Room</span>
                </div>

                <div *ngIf="hasAmenity('Music Room')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-music me-2"></i>
                  <span>Music Room</span>
                </div>

                <div *ngIf="hasAmenity('Swimming Pool')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-life-ring me-2"></i>
                  <span>Swimming Pool</span>
                </div>

                <div *ngIf="hasAmenity('Pool')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-tint me-2"></i>
                  <span>Pool</span>
                </div>

                <div *ngIf="hasAmenity('Game Room')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-gamepad me-2"></i>
                  <span>Game Room</span>
                </div>

                <div *ngIf="hasAmenity('Study Room')"
                  class="col-6 mb-3 d-flex align-items-center amenities-item">
                  <i class="fa fa-book me-2"></i>
                  <span>Study Room</span>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
    <div class="col-12 first-container">
      <mat-card class="project-overview">
        <mat-card-content>
          <div class="project-details">
            <div class="detail mt-2">
              <span class="posted" style="color: black;">Released : </span>
              <strong style="color: gray;">{{postdate | timeAgo }}</strong>
            </div>
            <div class="detail10 mt-2 button-container " style="gap:15px">
              <button mat-button class="right-align-button onlyhover"
                (click)="back()">Back</button>
              <button mat-button class="right-align-button onlyhover"
                (click)="openShareModal(listingData)"><i
                  class="fa fa-share-alt me-2" aria-hidden="true"></i>
                Share</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

  </div>
  <br>
  <app-footer></app-footer>
</div>
